<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-select v-model="filterParams.order_status" placeholder="请选择" class="header-input" @change="loadData(1)" width="120">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已支付" :value="1"></el-option>
                    <el-option label="未支付" :value="0"></el-option>
                </el-select>
                <el-input v-model="filterParams.user_phone" placeholder="请输入手机号码" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_name" placeholder="请输入商品名称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <!-- <el-table-column label="头像">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="scope.row.userImage" fit="cover"></el-image>
                </template>
            </el-table-column> -->
            <el-table-column prop="userNick" label="用户名称/手机号码" width="200">
                <template slot-scope="scope">
                    <div>{{ scope.row.userNick ? scope.row.userNick : "-" }}</div>
                    <div>{{ scope.row.userPhone ? scope.row.userPhone : "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="userNick" label="推荐人名称/手机号码" width="200">
                <template slot-scope="scope">
                    <div>{{ scope.row.recommandNick ? scope.row.recommandNick : "-" }}</div>
                    <div>{{ scope.row.recommandPhone ? scope.row.recommandPhone : "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="申请时间/支付时间" width="260">
                <template slot-scope="scope">
                    <div>请求时间：{{ convertToDate(scope.row.orderDateCreate) }}</div>
                    <div>支付时间：{{ convertToDate(scope.row.orderDateCreate) }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="productName" label="商品名称"></el-table-column>
            <el-table-column prop="orderStatus" label="状态">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.orderStatus == 1">已支付</el-tag>
                    <el-tag type="danger" v-if="scope.row.orderStatus == 0">未支付</el-tag>
                    <el-tag v-if="scope.row.orderStatus == 2">已取消</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="orderMemo" label="订单备注"></el-table-column>
            <el-table-column prop="orderMemo" label="核销数">
                <template slot-scope="scope">
                    <div v-if="scope.row.orderStatus == 1">{{ scope.row.courseRecordCount + "/" + scope.row.courseCount }}</div>
                    <div v-else>-</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('course', scope.row)" type="text" size="small" v-if="scope.row.orderStatus == 1">核销</el-button>
                    <el-button @click="handleClick('record', scope.row)" type="text" size="small"v-if="scope.row.orderStatus == 1">记录</el-button>
                    <el-popconfirm title="确认支付吗？" v-if="scope.row.orderStatus != 1" @confirm="orderPay(scope.row.orderId)"><el-button slot="reference" type="text" size="small" style="margin-left: 10px;">支付</el-button></el-popconfirm>
                    <el-popconfirm title="确认取消吗？" v-if="scope.row.orderStatus != 2" @confirm="orderCancel(scope.row.orderId)"><el-button slot="reference" type="text" size="small" style="margin-left: 10px;">取消</el-button></el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="50%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <!-- <el-form-item label="支付状态">
                        <el-select v-model="handleInfo.orderStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="已支付" :value="1"></el-option>
                            <el-option label="未支付" :value="0"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="订单备注">
                        <el-input v-model="handleInfo.orderMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            
            <div v-if="handle == 'course'">
                <el-table :data="courses" border style="width: 100%">
                    <el-table-column prop="courseSort" width="70" label="序号"></el-table-column>
                    <el-table-column prop="courseName" label="课程名称"></el-table-column>
                    <el-table-column prop="courseMemo" label="课程备注"></el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button @click="recordAdd(scope.row)" type="text" size="small">核销</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="handle == 'record'">
                <el-table :data="courseRecords" border style="width: 100%">
                    <el-table-column prop="courseSort" width="70" label="序号"></el-table-column>
                    <el-table-column prop="courseName" label="课程名称"></el-table-column>
                    <el-table-column label="核销时间">
                        <template slot-scope="scope">
                            <div>{{ convertToDate(scope.row.courseRecordDate) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button @click="recordDelete(scope.row.courseRecordId)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

import { API, doGet, doPost, doDelete } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            recordId: "",
            orderId: "",
            courses: [],
            courseRecords: []
        }
    },
    methods: {
        beforeHandleSubmit: function() {
            if (this.handle == "course" || this.handle == "record") {
                this.isHandle = false;
            }
        },
        beforeHandleOpenEx: async function(handle, info) {
            this.courses = [];
            this.courseRecords = [];
            this.orderId = info.orderId;
            if (handle == "course") {
                this.getOrderCourse();
            }
            else if (handle == "record") {
                this.getOrderRecord();
            }
        },
        getOrderCourse: async function() {
            this.courses = await doGet(API.ORDER_COURSE, {
                orderId: this.orderId
            });
        },
        getOrderRecord: async function() {
            this.courseRecords = await doGet(API.ORDER_RECORD, {
                orderId: this.orderId
            });
        },
        orderPay: async function(orderId) {
            let resultObj = await doGet(API.ORDER_PAY, {
                orderId: orderId
            });
            this.showResult(resultObj);
        },
        orderCancel: async function(orderId) {
            this.$nextTick(() => {
                this.$message("核销中，请稍后...")
            });
            let resultObj = await doGet(API.ORDER_CANCEL, {
                orderId: orderId
            });
            this.showResult(resultObj);
        },
        recordAdd: async function(course) {
            this.$confirm('此操作将核销当前课程, 是否继续?', '核销确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let recordResult = await doPost(API.COURSE_RECORD, {
                    courseId: course.courseId,
                    productId: course.productId,
                    orderId: this.orderId
                });
                this.showResultEx(recordResult);
                if (recordResult.errorCode == 0) {
                    this.getOrderCourse();
                }
            }).catch(res => { });
        },
        recordDelete: async function(recordId) {
            this.recordId = recordId;
            this.$confirm('此操作将删除当前核销, 是否继续?', '删除核销', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let recordResult = await doDelete(API.COURSE_RECORD, this.recordId);
                this.showResultEx(recordResult);
                if (recordResult.errorCode == 0) {
                    this.getOrderRecord();
                }
            }).catch(res => { });
        },
    },
    created: async function () {
        this.tag = "ORDER";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>